import { Button, Flex } from "@chakra-ui/react";
import { Inops } from "assets";
import { ResetPasswordForm } from "modules/auth";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ResetPasswordPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <Flex minH="100vh" bg="brand.blue.dark" align="center" justify="center">
      <Flex
        bg="white"
        p={8}
        justify="center"
        align="center"
        flexDirection="column"
        borderRadius={16}
        h="100%"
      >
        <Inops width="100%" height={74} />
        <ResetPasswordForm />
        <Flex mt={5} fontSize="sm">
          <Button
            variant={"link"}
            onClick={() => {
              navigate("/login");
            }}
          >
            {t(
              "reset_password_return_to_auth_page",
              "Revenir à la page d'authentification",
            )}
          </Button>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default ResetPasswordPage;
